import RestService from '@/services/RestService';
import statesEnum from '@/enums/statesEnum';

export default {
  methods: {
    afterLogin() {
      const token = this.$store.getters['UserStore/getToken'];
      if (!token) {
        this.$store.dispatch('ThemeStore/initialize');
        return;
      }
      const isParentApp = this.$store.getters['ConfigStore/isParentApp'];
      const isParent = this.$store.getters['UserStore/isParent'];
      const isTeacherApp = this.$store.getters['ConfigStore/isTeacherApp'];
      const isTeacher = this.$store.getters['UserStore/isTeacher'];
      const isStudentApp = this.$store.getters['ConfigStore/isStudentApp'];
      const isStudent = this.$store.getters['UserStore/isStudent'];

      const needRrdirectToParentApp =
        (isTeacherApp || isStudentApp) && isParent;
      const needRrdirectToStudentApp =
        (isTeacherApp || isParentApp) && isStudent;
      const needRrdirectToTeacherApp =
        (isStudentApp || isParentApp) && isTeacher;
      const hasWrongAppRole =
        needRrdirectToStudentApp ||
        needRrdirectToTeacherApp ||
        needRrdirectToParentApp;
      const isLocal = this.$store.getters['ConfigStore/isLocal'];

      if (hasWrongAppRole && isLocal) {
        this.$store.dispatch('UserStore/logout');
        this.$store.dispatch('ConfigStore/removeDemoToken');

        if (this.$route.name !== statesEnum.LOGIN) {
          this.$router.replace({
            name: statesEnum.LOGIN,
            query: { reason: 'wrong-role' },
          });
        }
        return;
      }

      if (needRrdirectToStudentApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectStudentUrl'
        ];
        window.location.href = redirectUrl;
        return;
      } else if (needRrdirectToTeacherApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectTeacherUrl'
        ];
        window.location.href = redirectUrl;
        return;
      } else if (needRrdirectToParentApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectParentUrl'
        ];
        window.location.href = redirectUrl;
        return;
      }

      RestService.setToken(token);
      this.$store.dispatch('ThemeStore/initialize');
      this.$router.push({
        name: this.routeAfterLogin,
        query: this.$route.query,
      });
    },
  },
};
